import React from "react";
import Menu from '../Menu';
import Footer from '../footer'

export default function notFoundPage() {
    return (
        <div>
            <Menu />
            <div className="main-block-registration">
                <div className="notFound">
                    <div className="notfounderror">404</div>
                    <div className="notFoundText">Сторінку не знайдено</div>
                </div>
            </div>
            <Footer />
        </div>
    );
}





// WEBPACK FOOTER //
// src/pages/notfoundpage.js